module.exports = __webpack_public_path__ + "img/logo-icrs.a04529d0.png";